(() => {
  const root = document.getElementById('pokespott-review-form');
  if (!root) return;

  const form = root.querySelector('[data-pokespott-review-form]');
  const success = root.querySelector('[data-pokespott-review-success]');
  if (!form || !success) return;

  const scrollToForm = () => {
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const firstInput = form.querySelector('input:not([type="hidden"]), textarea, select');
    firstInput?.focus({ preventScroll: true });
  };

  form.addEventListener('submit', () => {
    window.setTimeout(() => {
      form.hidden = true;
      success.hidden = false;
      scrollToForm();
    }, 600);
  });

  const hash = window.location.hash.replace(/^#/, '');
  if (hash === 'pokespott-review-form' || hash === 'ecrire-un-avis') {
    window.requestAnimationFrame(scrollToForm);
  }
})();
